import * as types from '../../constants/log/nftRestoreLogConstants';

export const nftRestoreLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  transactionNo,
  callback,
  error,
}) => ({
  type: types.NFT_RESTORE_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  nftUid,
  transactionNo,
  callback,
  error,
});
